import {InternalToolsModulePermissionCodes, MeasureModulePermissionCodes} from 'utils/types';
import {defineTabDef} from 'utils/helpers';

export const measureTabs = defineTabDef({
  sales_lift: {
    tabName: 'sales_lift',
    tabTitle: 'Sales Lift',
    requiredAnyPermission: [MeasureModulePermissionCodes.view_sales_lift],
  },
  sales_lift_stat_sig: {
    tabName: 'sales_lift_stat_sig',
    tabTitle: 'Statistical Significance',
    requiredAnyPermission: [InternalToolsModulePermissionCodes.view_statistical_significance],
  },
  pre_sales_report: {
    tabName: 'pre_sales_report',
    tabTitle: 'Pre-Sales Report',
    requiredAnyPermission: [MeasureModulePermissionCodes.view_pre_sales_report],
  },
  sales_report: {
    tabName: 'sales_report',
    tabTitle: 'Sales Report',
    requiredAnyPermission: [MeasureModulePermissionCodes.view_sales_report],
  },
  rfp: {
    tabName: 'rfp',
    tabTitle: 'RFP',
    requiredAnyPermission: [MeasureModulePermissionCodes.view_rfp],
  },
} as const);
